import React from "react";

export default function RadioGroup({
  name,
  options,
  value,
  onChange,
  describedBy,
}) {
  return (
    <div
      className="flex flex-wrap gap-2 justify-center sm:justify-start"
      role="radiogroup"
      aria-describedby={describedBy}
    >
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={value === opt.value}
          onClick={() => onChange(opt.value)}
          className={`px-3 py-1.5 rounded-full border text-sm transition ${
            value === opt.value
              ? "border-border-light bg-primary text-text-inverse"
              : "border-border-strong hover:bg-surface"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
